const ar = {
  language: 'العربية',
  hero: {
    headline: 'مركز السلامة للحجامة',
    subtitle: 'علاج طبيعي للصحة والعافية',
    cta: 'احجز الآن'
  },
  benefits: {
    title: 'فوائد الحجامة',
    items: [
      'تنشيط الدورة الدموية',
      'تخفيف الألم',
      'تعزيز المناعة',
      'إزالة السموم',
      'الاسترخاء وتقليل التوتر',
      'تحسين الصحة العامة'
    ]
  },
  howItWorks: {
    title: 'كيف تعمل الحجامة؟',
    steps: [
      'استشارة أولية',
      'تطبيق الكؤوس',
      'الرعاية بعد الجلسة'
    ]
  },
  testimonials: {
    title: 'آراء العملاء',
    items: [
      { name: 'أحمد', text: 'تجربة رائعة! شعرت بتحسن كبير بعد الجلسة.' },
      { name: 'سارة', text: 'خدمة احترافية ونتائج مذهلة.' },
      { name: 'يوسف', text: 'استقبال ممتاز ونتائج ملحوظة من أول جلسة.' }
    ]
  },
  about: {
    title: 'عن المعالج',
    text: 'معالج خبير في الحجامة الطبية\nو العلاجات الطبيعية'
  },
  pricing: {
    title: 'الأسعار',
    moreButton: 'اعرف المزيد'
  },
  services: {
    session1: {
      title: '🩸 الحجامة الرطبة',
      shortDesc: 'حجامة تقليدية',
      price: '100 dh',
      img: 'price1.png',
      longDesc: `الحجامة الرطبة هي طريقة علاجية تقليدية تعتمد على عمل خدوش سطحية في الجلد ثم سحب الدم الراكد باستخدام الكؤوس (الشفط).

الفوائد:

تنقية الجسم من السموم 

تنشيط الدورة الدموية

تخفيف الآلام المزمنة (كالظهر والرأس والمفاصل)

تقوية المناعة

تُستخدم في حالات مثل: الصداع، التعب المزمن، آلام العضلات، اضطرابات الهضم، آلام الدورة الشهرية، وغيرها.`
    },
    session2: {
      title: '🔥 الفوطة النارية',
      shortDesc: 'تحفيز الدورة الدموية',
      price: '80dh',
      img: 'price2.png',
      longDesc: `تقنية تقليدية تعتمد على تسخين منشفة مبللة بالكحول وتطبيقها بسرعة على الظهر، مما يساعد على إرخاء العضلات وتنشيط الدورة الدموية.

الفوائد:

تخفيف سريع للتشنجات العضلية

شعور بالدفء والاسترخاء العميق

تحفيز الدورة الدموية الموضعية

إزالة التوتر من منطقة الظهر والكتفين

مفيدة لمن يُعاني من: التوتر العصبي، آلام العضلات، تصلب الظهر`
    },
    session3: {
      title: '💆 تدليك علاجي',
      shortDesc: 'تدليك',
      price: '80dh',
      img: 'price3.png',
      longDesc: `جلسة تدليك يدوية تستهدف مناطق الشد والتوتر في الجسم، تساعد على استرخاء العضلات وتخفيف الضغوط النفسية.

الفوائد:

تقليل التوتر والقلق

تحسين جودة النوم

تخفيف آلام الرقبة والظهر والعضلات

استرخاء عام للجسم والعقل

مناسب لمن يُعاني من: الإرهاق، آلام العضلات، الأرق، التوتر العصبي`
    },
    special: {
      title: '💎 العرض الكامل',
      shortDesc: 'حجامة + تدليك + فوطة النارية',
      price: '150dh',
      img: 'price4.png',
      longDesc: `يتضمن:

الحجامة الرطبة 

الفوطة النارية

التدليك العلاجي

المميزات:
جلسة علاجية متكاملة تجمع بين تنقية الجسم، إرخاء العضلات، وتنشيط الدورة الدموية.

لمن يُناسب؟
مثالي للأشخاص الذين يشعرون بإرهاق شديد أو توتر عالٍ، ويرغبون في جلسة استشفاء شاملة ومتكاملة`
    }
  },
  faq: {
    title: 'الأسئلة الشائعة',
    questions: [
      { q: 'هل الحجامة مؤلمة؟', a: 'عادةً ما تكون غير مؤلمة، قد تشعر فقط بسحب خفيف.' },
      { q: 'كم عدد الجلسات المطلوبة؟', a: 'يعتمد ذلك على حالتك الصحية، غالباً من جلسة إلى ثلاث جلسات.' }
    ]
  },
  finalCta: {
    text: 'احجز جلستك الآن أو تواصل معنا عبر واتساب أو الهاتف.'
  },
  footer: {
    contact: 'معلومات التواصل',
    location: 'الموقع',
    follow: 'تابعنا'
  },
  serviceDetailsDescLabel: "الوصف",
  serviceDetailsLongDescLabel: "تفاصيل"
};

export default ar;
